import { message } from "antd"
import axios from "axios"
import { create } from "zustand"

export const useShops = create((set, get) => ({
    columns: [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Magazion', dataIndex: 'shopname', key: 'shopname' },
        { title: 'Manzil', dataIndex: 'address', key: 'address' },
        { title: 'Telefon', dataIndex: 'phone', key: 'phone' },
        { title: 'Xodim', dataIndex: 'seller', key: 'seller'},
    ],
    shops: [],
    ed: {},
    setEd: (v) => set({ ed: v }),

    getShops: () => {
        axios.get('shops').then(data => {
            set({ shops: data.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda hatolik")
        })
    },
    addShop: (shop) => {
        axios.post('shops', shop).then(() => {
            get().getShops()
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda hatolik")
        })
    },
    editShop: (shop) => {
        axios.put(`shops/${shop.id}`, shop).then(() => {
            get().getShops()
        }).catch(error => {
            message.error("Ma'lumotlarni tahrirlashda hatolik")
        })
    },
    deleteShop: (id) => {
        axios.delete('shops/' + id).then(res => {
            get().getShops()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    }
}))